import { Avatar } from '@sp/ui/elements';
import { ReactElement } from 'react';

export function ChatMessageAvatarView({
  avatar,
  author,
}: Readonly<{ author: string; avatar: string | null }>): ReactElement {
  return <Avatar size="sm" name={author} src={avatar} />;
}
